import { ModelBase } from "../shared/model.base";

export class SmsCsvDTO extends ModelBase {
    file: any;
    serviceType: string;
    name: string;
    delimeter: string;
    IdShortCode: number;
    longUrl: string;
    validityPeriod: number;
    obfuscated: boolean;

    constructor() {
        super();

        this.file = null;
        this.name = "";
        this.delimeter = "";
        this.IdShortCode = null;
        this.serviceType = "0";
    }
}
